<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="serviceRequestService.showDetailedView"
         [ngStyle]="{width: (serviceRequestService.showDetailedView && (screenWidth > 768)) ? 'calc(100% - 420px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Service Request'" [buildings]="serviceRequestService.buildingsForRead"></filter>
                </div>
                <div [hidden]="serviceRequestService.showDetailedView">
                    <service-request-filter></service-request-filter>
                </div>
                <div *ngIf="serviceRequestService.canEdit() && serviceRequestService.residentAccessController(action.requestCreate)"
                     [ngClass]="{'col-sm-5' : serviceRequestService.showDetailedView,
                                 'col-sm-3' : !serviceRequestService.showDetailedView}">
                    <button type="button"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="serviceRequestService.isServiceRequestModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Request
                    </button>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allServiceRequests'" [ngClass]="{'sk-loading': serviceRequestService.spinnerShow}">
                    <service-request-list></service-request-list>
                    <spinner [spinnerShow]="serviceRequestService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="serviceRequestService.data.allServiceRequests.total && urlService.queryParams['page']"
                            [total]="serviceRequestService.data['allServiceRequests'].total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="isDesktop animated animated-directory slideInRight detailed-view dv-sidebar">
        <service-detail-section></service-detail-section>
    </div>
</div>
<div class="animated animated-directory slideInRight detailed-view dv-sidebar table-mobile">
    <service-detail-section></service-detail-section> <!-- TODO: <<<= REMOVE DUPLICATE DIRECTIVE USAGE -->
</div>
<service-request-modal *ngIf="serviceRequestService.isServiceRequestModalShow"></service-request-modal>
<service-add-comment-assign-to-modal *ngIf="serviceRequestService.showAddCommentModal || serviceRequestService.showAssignToModal">
</service-add-comment-assign-to-modal>

<view-attachment-modal *ngIf="serviceRequestService.es.isViewAttachmentModalShow"></view-attachment-modal>



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-request.component.html